import(/* webpackMode: "eager", webpackExports: ["SiteClient"] */ "/vercel/path0/apps/web/src/app/(site)/site/[slug]/site-client.tsx");
